import React from "react"
import Content from "../Content/Content"
import Section from "../Section/Section"
import * as styles from "./FeatureCategories.module.css"

import hardware from "../../../../images/landing/platform/icon-hardware.webp"
import software from "../../../../images/landing/platform/icon-software.webp"
import dashboard from "../../../../images/landing/platform/icon-dashboard.webp"
import caution from "../../../../images/landing/platform/icon-caution.webp"
import trend from "../../../../images/landing/platform/icon-trend.webp"
import emotion from "../../../../images/landing/platform/icon-emotion.webp"

const Icons = [
  { image: hardware, name: "Hardware" },
  { image: software, name: "Software" },
  { image: dashboard, name: "Analytics" },
  { image: caution, name: "Alerts" },
  { image: trend, name: "Trend & prediction" },
  { image: emotion, name: "Emotion Detection" },
]

const FeatureCategories = () => {
  return (
    <Content columns={3} gap={40}>
      {Icons.map(({ image, name }) => (
        <Section key={name} fullResponsive style={{ textAlign: "center" }}>
          <div className={styles.item}>
            <img src={image} alt={name} />
          </div>
          <span>{name}</span>
        </Section>
      ))}
    </Content>
  )
}

export default FeatureCategories
